<template>
  <v-client-table
    :data="tableItems"
    :columns="table.columns"
    :options="table.options"
    class="table-default table-default--40"
  >
    <template #h__name><div class="table-default__left">Name</div></template>
    <template #name="{ row }">
      <router-link
        :to="{ name: 'administrative-properties-detail-lease-agreements', params: { id: row.id } }"
        class="table-default__link-border"
      >
        {{ row.name }}
      </router-link>
    </template>
    <template #lease="{ row }">
      <template v-if="row.min_agreement_date">{{ dateFormat(row.min_agreement_date) }} - {{ dateFormat(row.max_agreement_date) }}</template>
      <template v-else>-</template>
    </template>
  </v-client-table>
</template>

<script>
import {format, parseISO} from 'date-fns'

export default {
  name: 'TableProperties',
  props: ['tableItems'],
  data() {
    return {
      table: {
        columns: ['name', 'lease'],
        options: {
          headings: {
            name: 'Name',
            lease: 'Lease',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  methods: {
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : ''
    },
  },
}
</script>
